<template src="./template.html" />

<script>

import LandingPages from 'src/modules/pages/landing-page'
import { canInCollection } from 'naf-acl'
import moment from 'moment'
import FilterBox from '@/components/filter-box'

const DEFAULT_FILTER = [['@deleted', '==', false], ['metaData.byEmail', 'array-contains', null]]
const COLLECTION = 'MeetingMinutes'

export default {
  name: 'MeetingMinutesLanding',
  components: {
    LandingPages,
    FilterBox
  },
  props: {
    backLink: {
      type: [String, Object],
      default: '/'
    },
    queryConditions: {
      type: Object,
      default: () => ({
        ref: [COLLECTION],
        filter: [['@deleted', '==', false], ['metaData.byEmail', 'array-contains', null]],
        order: ['dateTakePlace', 'desc'],
        limit: 50,
        returnSnapshot: true 
      })
    },
    canCreate: {
      type: Boolean,
      default: true
    },
    detailRoute: {
      type: [String, Object],
      default: '/meeting-minutes/detail'
    }
  },
  data () {
    return {
      DEFAULT_FILTER: this.queryConditions.filter ? this._.cloneDeep(this.queryConditions.filter) : null,
      privateQueryConditions: this.queryConditions,
      tableConfig: {
        pagination: {
          'rowsPerPage': 50,
          'rowsNumber': 50,
          'descending': true,
        }
      },
      headers: [
        // {
        //   label: 'Khối nghiệp vụ',
        //   align: 'left',
        //   name: 'bu',
        //   field: 'bu',
        //   labelFormat: `this.R.path(['label'], $this) || ''`
        // },
        {
          label: 'Phòng ban',
          align: 'left',
          name: 'department',
          field: 'department',
          labelFormat: `this.R.path(['name'], $this) || ''`
        },
        {
          label: 'Ngày diễn ra cuộc họp',
          align: 'left',
          name: 'dateTakePlace',
          field: 'dateTakePlace',
          labelFormat: `$this && typeof $this.toDate === 'function' ? moment.utc($this.toDate()).format('DD/MM/YYYY') : ''`
        },
        {
          label: 'Thời gian diễn ra cuộc họp',
          align: 'left',
          name: 'meetingStartTime',
          field: 'meetingStartTime',
          labelFormat: `($this || '') + ' - ' + (this.R.path(['meetingEndTime'], row) || '')`
        },
        {
          label: 'Địa điểm',
          align: 'left',
          name: 'location',
          field: 'location'
        },
        {
          label: 'Tiêu đề',
          align: 'left',
          name: 'title',
          field: 'title'
        },
        {
          label: 'Thư ký',
          align: 'left',
          name: 'metaData',
          field: 'metaData',
          labelFormat: `this.R.path(['createdBy'], $this)`
        },
        {
          label: 'Chủ trì',
          align: 'left',
          name: 'host',
          field: 'host',
          // labelFormat: `this.R.path(['createdBy'], $this)`
        },
        {
          label: 'Đối tác',
          align: 'left',
          name: 'otherParticipants',
          field: 'otherParticipants',
          // labelFormat: `this.R.path(['createdBy'], $this)`
        }
      ],
      defaultQuery: this.R.clone(this.queryConditions),
      landingPagesConfig: {
        backLink: this.backLink,
        routeDetailName: this.detailRoute,
        canCreate: this.canCreate,
        canCopy: false
      },
      conditions: [
        {
          config: {
            label: 'Phòng ban',
            icon: 'store',
            datasource: {
              options: [],
              label: 'name',
              value: 'id',
              emitValue: true
            },
            sortBy: 'name',
            clearable: true,
            useInput: true,
            fieldName: 'department',
            mapOptions: true
          },
          mapLabel: (value, options) => {
            let filter = options.filter(item => item.id === value)
            if(filter[0]) {
              return filter[0].name
            }
            return ''
          },
          query: ['department.id', '==', 'this']
        },
        // {
        //   config: {
        //     label: 'Khối',
        //     icon: 'store',
        //     datasource: {
        //       options: [],
        //       label: 'label',
        //       value: 'value',
        //       emitValue: true
        //     },
        //     sortBy: 'name',
        //     clearable: true,
        //     useInput: true,
        //     fieldName: 'bu',
        //     mapOptions: true
        //   },
        //   mapLabel: (value, options) => {
        //     let filter = options.filter(item => item.value === value)
        //     if(filter[0]) {
        //       return filter[0].label
        //     }
        //     return ''
        //   },
        //   query: ['bu.value', '==', 'this']
        // },
        {
          config: {
            label: 'Ngày diễn ra cuộc họp',
            icon: 'store',
            datasource: {
              options: [],
              label: 'label',
              value: 'value',
              emitValue: true
            },
            fieldName: 'dateTakePlace',
            type: 'DatePicker'
          },
          mapLabel: (value, options) => {
            return moment(value.toDate()).format('DD/MM/YYYY')
          },
          query: ['dateTakePlace', '==', 'this']
        },
        {
          config: {
            label: 'Thư ký',
            icon: 'people',
            datasource: {
              options: [],
              value: 'email',
              label: 'displayName',
              emitValue: true
            },
            after: {
              func: this.assignToMe
            },
            mapOptions: true,
            useInput: true,
            fieldName: 'metaData.createdBy',
            clearable: true
          },
          show: true,
          query: ['metaData.createdBy', '==', 'this']
        },
        {
          config: {
            label: 'Chủ trì cuộc họp',
            icon: 'people',
            datasource: {
              options: [],
              value: 'email',
              label: 'displayName',
              emitValue: true
            },
            after: {
              func: this.assignToMe
            },
            mapOptions: true,
            useInput: true,
            fieldName: 'host',
            clearable: true
          },
          show: true,
          query: ['host', '==', 'this']
        }
      ],
      masterData: null,
      disableFreeText: true,
      conditionsFreeText: undefined
    }
  },
  created() {
    this.fetchMasterData()
    if(this.queryConditions.filter[1][0] === 'metaData.byEmail') {
      this.DEFAULT_FILTER[1][2] = this.$store.state.user.email
      this.privateQueryConditions.filter[1][2] = this.$store.state.user.email
      this.defaultQuery.filter[1][2] = this.$store.state.user.email
    }
  },
  methods: {
    fetchMasterData() {
      this.$query(['MasterData', 'Department']).then(res => {
        this.masterData = res
        // let result = this._.values(this._.omit(res,'metaData'))
        // this.conditions[0].config.datasource.options = result || []
        this.conditions[0].config.datasource.options = this._.values(this._.omit(res,'metaData')) || []
        // this.conditions[1].config.datasource.options = this.R.path(['listBU'], this.masterData) || []
      })
      this.$query(['Users', 'UsersIndex']).then(res => {
        this.conditions[2].config.datasource.options = res.list
        this.conditions[3].config.datasource.options = res.list
      })
    },
    async handlerDetail (id) {
      let vm = this
      let dataFetched = await this.$query([COLLECTION, id])
      this.$router.push({
        name: vm.landingPagesConfig.routeDetailName,
        query: {
          id: id
        },
        params: {
          id: id,
          mode: 'EDIT',
          department: this.deparment,
          data: dataFetched
        }
      })
    },
    handlerAddButtonClick () {
      let vm = this
      vm.$router.push({ name: vm.landingPagesConfig.routeDetailName, params: { mode: 'CREATE' } })
    },
    canInCollection,
    query(value) {
      // console.log(JSON.stringify(value))
      let haveDateTakePlace = value.filter.filter(item => item[0] === 'dateTakePlace')
      if(haveDateTakePlace.length > 0) {
        value.order = null
      }
      this.privateQueryConditions = value
      if(this.$refs.landingPage) {
        this.$refs.landingPage.$emit('updateQueryConditions', this.privateQueryConditions)
        this.$refs.landingPage.$emit('fetchData')
      }
    },
    canDelete() {
      return false
    },
    assignToMe(components, value, options) {
      if(this.$store.getters.user.email) {
        components.$emit('input', this.$store.getters.user.email)
      }
    }
  }
}
</script>
